import React from 'react';

export const GoToIcon = ({ fill = '#05050D' }) => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.8"
        d="M12.5441 12.5444H1.65516V1.65553H7.09961V0.0999756H0.0996094V14.1H14.0996V7.09998H12.5441V12.5444ZM8.65516 0.0999756V1.65553H11.4474L3.80183 9.30109L4.8985 10.3978L12.5441 2.7522V5.54442H14.0996V0.0999756H8.65516Z"
        fill="#05050D"
        stroke="#05050D"
        strokeWidth="0.2"
      />
    </svg>
  );
};
